import React, { useEffect, useMemo, useRef, useState } from "react";
import { Typography, Button, Box, makeStyles } from "@material-ui/core";
import paymentCardsImage from "../../assets/images/paymntCards.png";
import ccBillIcon from "../../assets/images/ccBilll.png";
import markIcon from "../../assets/svgs/markIcon.svg";
import md5 from "md5";
import { checkUserSubscriptionAPI } from "../../api/userApi";
import { makeOneClickPayment } from "../../api/ccbillApi";
import { toast } from "react-toastify";
import { getAllTokens } from "../../api/ccbillApi";
import SuccessModal from "./SuccessModal";

const useStyles = makeStyles(theme => ({
  ccbillContainer: {
    background: "#131313",
    borderRadius: "12px",
    padding: "0 24px 32px 24px",
    border: "none",
    textAlign: "center",
    maxWidth: "500px",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      padding: "0 16px 24px 16px",
      margin: "0",
    },
  },
  ccbillContainerSubscriptionWide: {
    maxWidth: "min(100%, 560px)",
    width: "100%",
  },
  ccbillContainerMinimal: {
    padding: 0,
    margin: 0,
    background: "transparent",
    maxWidth: "100%",
  },
  subscriptionSummaryCard: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 1px minmax(0, 1fr)",
    alignItems: "center",
    columnGap: "20px",
    backgroundColor: "#191919",
    border: "1px solid #363636",
    borderRadius: "16px",
    padding: "20px",
    marginBottom: "24px",
    marginLeft: "auto",
    marginRight: "auto",
    boxSizing: "border-box",
    textAlign: "left",
    width: "100%",
    maxWidth: "560px",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      gap: "16px",
      gridTemplateColumns: "none",
    },
  },
  subscriptionSummaryLeft: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  subscriptionTierBadge: {
    alignSelf: "flex-start",
    borderRadius: "20px",
    backgroundColor: "#FF78AA",
    color: "#0C0A09",
    fontSize: "16px",
    fontWeight: 500,
    padding: "6px 16px",
    lineHeight: 1.2,
    fontFamily: "Work Sans, sans-serif",
  },
  subscriptionPriceRow: {
    display: "flex",
    alignItems: "baseline",
    gap: "8px",
    flexWrap: "wrap",
  },
  subscriptionPriceAmount: {
    color: "#FFFFFF",
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: 1.1,
    fontFamily: "Work Sans, sans-serif",
  },
  subscriptionPricePeriod: {
    color: "#FFFFFF",
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: "Work Sans, sans-serif",
  },
  subscriptionRenewalLine: {
    color: "#747474",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: 1.4,
    fontFamily: "Work Sans, sans-serif",
  },
  subscriptionSummaryDivider: {
    width: "1px",
    height: "80px",
    backgroundColor: "#2A2A2A",
    justifySelf: "center",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "1px",
      justifySelf: "stretch",
    },
  },
  subscriptionSummaryRight: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  subscriptionBenefitRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  subscriptionBenefitMark: {
    width: "16px",
    height: "16px",
    flexShrink: 0,
  },
  subscriptionBenefitText: {
    color: "#FFFFFF",
    fontSize: "14px",
    lineHeight: 1.35,
    fontFamily: "Work Sans, sans-serif",
  },
  securityIconContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "16px",
  },
  securityIcon: {
    width: "180px",
    height: "180px",
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      width: "110px",
      height: "110px",
    },
  },
  purchaseInfo: {
    backgroundColor: "transparent",
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "24px",
    border: "none",
    textAlign: "left",
  },
  purchaseTitle: {
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "12px",
    fontFamily: "Work Sans, sans-serif",
  },
  purchaseItem: {
    color: "#cccccc",
    fontSize: "14px",
    marginBottom: "8px",
    fontFamily: "Work Sans, sans-serif",
  },
  purchaseRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  purchaseLabel: {
    color: "#cccccc",
    fontSize: "14px",
    fontFamily: "Work Sans, sans-serif",
  },
  totalPrice: {
    color: "#ffffff",
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "Work Sans, sans-serif",
  },
  ccbillTitle: {
    color: "#ffffff",
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: "12px",
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  ccbillDescription: {
    color: "#cccccc",
    fontSize: "14px",
    lineHeight: "1.5",
    marginBottom: "20px",
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  ccbillFeatures: {
    color: "#ffffff",
    fontSize: "12px",
    lineHeight: "1.6",
    marginBottom: "24px",
    textAlign: "left",
    background: "#0f0f0f",
    padding: "12px 16px",
    borderRadius: "6px",
    border: "1px solid #2a2a2a",
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
      padding: "10px 12px",
    },
  },
  proceedButton: {
    backgroundColor: "#FE5A97",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    padding: "10px 24px",
    borderRadius: "8px",
    textTransform: "none",
    marginBottom: "16px",
    fontFamily: "Work Sans, sans-serif",
    "&:hover": {
      backgroundColor: "#ff85c1",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(255, 105, 180, 0.3)",
    },
    transition: "all 0.3s ease",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      padding: "12px 20px",
    },
  },
  ccbillButton: {
    backgroundColor: "transparent",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    padding: "10px 24px",
    borderRadius: "8px",
    border: "1px solid #FE5A97",
    textTransform: "none",
    marginBottom: "16px",
    fontFamily: "Work Sans, sans-serif",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    "&:hover": {
      backgroundColor: "#FE5A97",
      borderColor: "#FE5A97",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(254, 90, 151, 0.3)",
    },
    transition: "all 0.3s ease",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      padding: "12px 20px",
    },
  },
  ccbillButtonSubscriptionCheckout: {
    maxWidth: "490px",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  proceedButtonSubscriptionCheckout: {
    maxWidth: "490px",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  ccbillIcon: {
    width: "100px",
    height: "24px",
    objectFit: "contain",
  },
  ccbillNote: {
    color: "#999999",
    fontSize: "11px",
    lineHeight: "1.4",
    fontStyle: "italic",
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
}));

type CCBillContext =
  | "registration"
  | "custom-video"
  | "subscription"
  | "settings"
  | "post-purchase"
  | "tip"
  | "message-purchase";

interface PaymentToken {
  id: string;
  last4: string;
  expDate: string;
  cardType: string;
  isEnabled: boolean;
  createdAt: string;
}
export interface PaymentTokenResponse {
  cards: PaymentToken[];
  userId: string;
}

/** Checkout card for creator subscription (profile modal step 2) */
export interface SubscriptionCheckoutSummary {
  planName: string;
  benefits: string[];
  billingPeriod: "week" | "month";
}

interface Props {
  onProceed: () => void;
  price?: number;
  title?: string;
  description?: string;
  buttonText?: string;
  showPrice?: boolean;
  context?: CCBillContext;
  userId?: string;
  email?: string;
  postId?: string;
  tipForUserId?: string;
  messageId?: string;
  subscriptionToUserId?: string;
  isTestMode?: boolean;
  customVideoForUserId?: string;
  modelId?: string;
  conversationId?: string; // For tip messages in conversations
  onPaymentSuccess?: () => void; // New callback for successful payment
  showSuccessOnPayment?: boolean; // Show success modal after payment
  /**
   * Optional override for creator subscription flows:
   * when provided (for context === "subscription"), we treat this as
   * "already subscribed to this specific plan", instead of relying on the
   * global creator subscription check.
   */
  isAlreadySubscribedToPlan?: boolean;
  subscriptionInitialPrice?: number;
  subscriptionInitialPeriod?: number;
  subscriptionRecurringPrice?: number;
  subscriptionRecurringPeriod?: number;
  subscriptionNumRebills?: number;
  subscriptionSummary?: SubscriptionCheckoutSummary;
  /** Тільки кнопка CCBill (для UnlockPaidContentModal) */
  compactPostPurchase?: boolean;
  /** Автоматично одразу редіректити в CCBill (без додаткового кліку) */
  autoProceed?: boolean;
  /** Викликається перед переходом на CCBill */
  onRedirectToCCBill?: () => void;
}

const CCBillPayment: React.FC<Props> = ({
  price,
  title = "Secure Payment Processing",
  description,
  buttonText = "Pay with CCBill",
  showPrice = true,
  context = "",
  userId,
  subscriptionToUserId,
  tipForUserId,
  email = "",
  postId,
  messageId,
  modelId,
  conversationId,
  onPaymentSuccess,
  showSuccessOnPayment = true,
  isAlreadySubscribedToPlan,
  subscriptionInitialPrice,
  subscriptionInitialPeriod,
  subscriptionRecurringPrice,
  subscriptionRecurringPeriod,
  subscriptionNumRebills,
  subscriptionSummary,
  compactPostPurchase = false,
  autoProceed = false,
  onRedirectToCCBill,
}) => {
  const classes = useStyles();
  const [isAlreadySubscribed, setIsAlreadySubscribed] = useState(false);
  const [checkingSubscription, setCheckingSubscription] = useState(false);
  const [last4, setLast4] = useState<string | null>(null);
  const [hasToken, setHasToken] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const autoProceedTriggeredRef = useRef(false);

  const effectiveAlreadySubscribed =
    context === "subscription" && typeof isAlreadySubscribedToPlan === "boolean"
      ? isAlreadySubscribedToPlan
      : isAlreadySubscribed;

  useEffect(() => {
    getAllTokens()
      .then((response: PaymentTokenResponse) => {
        const active = response.cards.find(t => t.isEnabled);
        if (active) {
          setLast4(active.last4);
          setHasToken(true);
        } else {
          setHasToken(false);
        }
      })
      .catch(() => {
        setHasToken(false);
      });
  }, []);

  useEffect(() => {
    // Глобальна перевірка підписки через CCBill:
    // - використовуємо її тільки коли:
    //   1) context === "subscription"
    //   2) є subscriptionToUserId
    //   3) НЕ передано isAlreadySubscribedToPlan (глобальний флоу, не конкретний план)
    if (
      context === "subscription" &&
      subscriptionToUserId &&
      typeof isAlreadySubscribedToPlan !== "boolean"
    ) {
      setCheckingSubscription(true);
      checkUserSubscriptionAPI(subscriptionToUserId)
        .then(res => {
          if (res.isActive) {
            setIsAlreadySubscribed(true);
          }
        })
        .catch(err => {
          console.error("🔴 Subscription check failed:", err);
        })
        .finally(() => {
          setCheckingSubscription(false);
        });
    }
  }, [context, subscriptionToUserId, isAlreadySubscribedToPlan]);

  const getDefaultDescription = () => {
    switch (context) {
      case "registration":
        return "Set up your payment method securely with our trusted payment partner CCBill.";
      case "custom-video":
        return `Your payment${
          price && showPrice ? ` of $${price}` : ""
        } will be securely processed by CCBill.`;
      case "subscription":
        return "Subscribe securely through CCBill's protected payment system.";
      case "settings":
        return "Manage your payment methods and billing information through CCBill.";
      case "post-purchase":
        return `Unlock this content for ${
          price && showPrice ? `$${price}` : "the specified amount"
        } with CCBill.`;
      case "message-purchase":
        return `Unlock this message for ${
          price && showPrice ? `$${price}` : "the specified amount"
        } with CCBill.`;
      default:
        return `Your payment${
          price && showPrice ? ` of $${price}` : ""
        } will be securely processed by CCBill.`;
    }
  };

  const finalDescription = description || getDefaultDescription();

  const subscriptionRenewalShortDate = useMemo(() => {
    if (!subscriptionSummary) return "";
    const d = new Date();
    d.setDate(
      d.getDate() + (subscriptionSummary.billingPeriod === "week" ? 7 : 30)
    );
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  }, [subscriptionSummary]);

  const getPurchaseItemName = () => {
    switch (context) {
      case "subscription":
        return "Subscription";
      case "custom-video":
        return "Custom Video Request";
      case "post-purchase":
        return "Post Unlock";
      case "message-purchase":
        return "Message Unlock";
      case "tip":
        return "Tip";
      case "registration":
        return "Registration";
      default:
        return "Purchase";
    }
  };

  const handleProceedToCCBill = () => {
    const canProceedWithAmount =
      typeof price === "number" ||
      (context === "subscription" &&
        typeof subscriptionRecurringPrice === "number");
    if (!canProceedWithAmount || isAlreadySubscribed) return;
    const resolvedRecipientId = tipForUserId || subscriptionToUserId || modelId;

    // Self‑payment guard is disabled for subscription flows
    if (context !== "subscription" && userId === resolvedRecipientId) {
      toast.error("You cannot pay yourself.");
      return;
    }

    const flexFormId = process.env.REACT_APP_CCBILL_FLEXFORM_ID;
    const clientAccnum = process.env.REACT_APP_CCBILL_ACCOUNT;
    const clientSubacc =
      context === "subscription"
        ? process.env.REACT_APP_CCBILL_SUB_ACCOUNT_RECURRING
        : process.env.REACT_APP_CCBILL_SUB_ACCOUNT;
    const initialPriceValue =
      context === "subscription" && typeof subscriptionInitialPrice === "number"
        ? subscriptionInitialPrice
        : price;
    const initialPeriod =
      context === "subscription" &&
      typeof subscriptionInitialPeriod === "number"
        ? subscriptionInitialPeriod
        : 30;
    const currencyCode = 840;
    const salt = process.env.REACT_APP_CCBILL_SALT;
    const recurringPriceValue =
      context === "subscription" &&
      typeof subscriptionRecurringPrice === "number"
        ? subscriptionRecurringPrice
        : initialPriceValue;
    const recurringPeriod =
      context === "subscription" &&
      typeof subscriptionRecurringPeriod === "number"
        ? subscriptionRecurringPeriod
        : 30;
    const numRebills =
      context === "subscription" &&
      typeof subscriptionNumRebills === "number"
        ? subscriptionNumRebills
        : 99;
    const normalizeSubscriptionPrice = (
      value: number,
      options?: { allowZero?: boolean }
    ) => {
      const minValue = options?.allowZero ? 0 : 2;
      if (!Number.isFinite(value)) return minValue;
      return Math.min(399, Math.max(minValue, value));
    };
    const normalizedInitialPriceValue =
      context === "subscription"
        ? normalizeSubscriptionPrice(Number(initialPriceValue ?? 0), {
            allowZero: true,
          })
        : Number(initialPriceValue ?? 0);
    const normalizedRecurringPriceValue =
      context === "subscription"
        ? normalizeSubscriptionPrice(Number(recurringPriceValue ?? 0))
        : Number(recurringPriceValue ?? 0);
    const initialPrice = normalizedInitialPriceValue.toFixed(2);
    const recurringPrice = normalizedRecurringPriceValue.toFixed(2);
    // #region agent log
    fetch("http://127.0.0.1:7574/ingest/4c4a54fc-6a32-45fd-bdf3-4c3c66ca0dc3", { method: "POST", headers: { "Content-Type": "application/json", "X-Debug-Session-Id": "01f43b" }, body: JSON.stringify({ sessionId: "01f43b", runId: "pre-fix-trial-ccbill-range", hypothesisId: "H6", location: "CCBillPayment.tsx:560", message: "ccbill price range normalization", data: { context, initialPriceRaw: initialPriceValue, recurringPriceRaw: recurringPriceValue, initialPriceNormalized: initialPrice, recurringPriceNormalized: recurringPrice }, timestamp: Date.now() }) }).catch(() => {});
    // #endregion

    const formDigest =
      context === "subscription"
        ? md5(
            `${initialPrice}${initialPeriod}${recurringPrice}${recurringPeriod}${numRebills}${currencyCode}${salt}`
          ).toLowerCase()
        : md5(
            `${initialPrice}${initialPeriod}${currencyCode}${salt}`
          ).toLowerCase();

    const baseUrl = process.env.REACT_APP_CCBILL_BASE_URL;

    if (!flexFormId || !clientAccnum || !clientSubacc || !salt) {
      console.error("Missing required CCBill configuration");
      return;
    }
    const returnUrl = `https://sugarcribs.com${window.location.pathname}${window.location.search}`;

    const queryParams = [
      `clientAccnum=${encodeURIComponent(clientAccnum)}`,
      `clientSubacc=${encodeURIComponent(clientSubacc)}`,
      `initialPrice=${encodeURIComponent(initialPrice)}`,
      `initialPeriod=${encodeURIComponent(initialPeriod)}`,
      `currencyCode=${encodeURIComponent(currencyCode)}`,
      `formDigest=${encodeURIComponent(formDigest)}`,
      `email=${encodeURIComponent(email || "")}`,
      `formName=StandardForm`,
      `returnUrl=${encodeURIComponent(returnUrl)}`,
    ];

    if (context !== "custom-video") {
      queryParams.push(`userId=${encodeURIComponent(userId || "")}`);
      queryParams.push(`context=${encodeURIComponent(context || "custom")}`);
    }

    if (context === "subscription") {
      queryParams.push(`recurringPrice=${encodeURIComponent(recurringPrice)}`);
      queryParams.push(
        `recurringPeriod=${encodeURIComponent(recurringPeriod)}`
      );
      queryParams.push(`numRebills=${encodeURIComponent(numRebills)}`);
      queryParams.push(
        `subscriptionToUserId=${encodeURIComponent(subscriptionToUserId || "")}`
      );
    } else if (context === "post-purchase" && postId) {
      queryParams.push(`galleryId=${encodeURIComponent(postId)}`);
    } else if (context === "message-purchase" && messageId) {
      queryParams.push(`messageId=${encodeURIComponent(messageId)}`);
    }
    if (context === "tip" && tipForUserId) {
      queryParams.push(`tipForUserId=${encodeURIComponent(tipForUserId)}`);
      if (conversationId) {
        queryParams.push(
          `conversationId=${encodeURIComponent(conversationId)}`
        );
      }
    } else if (context === "custom-video") {
      queryParams.push(`userId=${encodeURIComponent(userId || "")}`);
      queryParams.push(`creatorId=${encodeURIComponent(modelId || "")}`); // Changed from modelId to creatorId
      queryParams.push(`description=${encodeURIComponent(description || "")}`);
      queryParams.push(`context=custom-video`);
    }

    const paymentUrl = `${baseUrl}/${flexFormId}?${queryParams.join("&")}`;

    try {
      // #region agent log
      fetch("http://127.0.0.1:7574/ingest/4c4a54fc-6a32-45fd-bdf3-4c3c66ca0dc3", { method: "POST", headers: { "Content-Type": "application/json", "X-Debug-Session-Id": "01f43b" }, body: JSON.stringify({ sessionId: "01f43b", runId: "pre-fix-trial-flexform", hypothesisId: "F3", location: "CCBillPayment.tsx:625", message: "redirecting to ccbill", data: { context, autoProceed, subscriptionToUserId: subscriptionToUserId || null, hasOnRedirectToCCBill: typeof onRedirectToCCBill === "function" }, timestamp: Date.now() }) }).catch(() => {});
      // #endregion
      onRedirectToCCBill?.();
      window.location.href = paymentUrl;
    } catch (error) {
      console.error("Error redirecting to CCBill:", error);
    }
  };

  useEffect(() => {
    if (!autoProceed) return;
    if (checkingSubscription) return;
    if (effectiveAlreadySubscribed) return;
    if (autoProceedTriggeredRef.current) return;
    autoProceedTriggeredRef.current = true;
    handleProceedToCCBill();
  }, [autoProceed, checkingSubscription, effectiveAlreadySubscribed]);
  // const handleSaveCardFlexForm = () => {
  //     const flexFormId = process.env.REACT_APP_CCBILL_FLEXFORM_ID;
  //     const clientAccnum = process.env.REACT_APP_CCBILL_ACCOUNT;
  //     const clientSubacc = process.env.REACT_APP_CCBILL_SUB_ACCOUNT;
  //     const initialPrice = "0.01";
  //     const initialPeriod = 30;
  //     const currencyCode = 840;
  //     const salt = process.env.REACT_APP_CCBILL_SALT;
  //
  //     const formDigest = md5(`${initialPrice}${initialPeriod}${currencyCode}${salt}`).toLowerCase();
  //     const baseUrl = process.env.REACT_APP_CCBILL_BASE_URL;
  //
  //     const queryParams = [
  //         `clientAccnum=${clientAccnum}`,
  //         `clientSubacc=${clientSubacc}`,
  //         `initialPrice=${initialPrice}`,
  //         `initialPeriod=${initialPeriod}`,
  //         `currencyCode=${currencyCode}`,
  //         `formDigest=${formDigest}`,
  //         `userId=${userId}`, // 👈 ОБОВ'ЯЗКОВО для вебхука
  //         `context=saveCard`,
  //         `formName=StandardForm`,
  //     ];
  //
  //     const flexUrl = `${baseUrl}/${flexFormId}?${queryParams.join("&")}`;
  //
  //     window.location.href = flexUrl;
  // };

  const handleOneClickPayment = async () => {
    if (!price || !context) return;

    try {
      const tokens: PaymentTokenResponse = await getAllTokens();
      const activeToken = tokens.cards.find(t => t.isEnabled);
      if (!activeToken) {
        toast.error("No active card available");
        return;
      }

      // For credit purchases (post-purchase context), use userId as recipientId
      // For other contexts, resolve from context-specific props
      let resolvedRecipientId: string | null = null;
      if (context === "post-purchase") {
        // Credit purchases: user is buying credits for themselves
        resolvedRecipientId = userId || null;
      } else {
        resolvedRecipientId =
          tipForUserId || subscriptionToUserId || modelId || null;
        // Check if trying to pay yourself (except for credit purchases and subscription flows)
        if (
          context !== "subscription" &&
          userId &&
          userId === resolvedRecipientId
        ) {
          toast.error("You cannot pay yourself.");
          return;
        }
      }

      const payload = {
        recipientId: resolvedRecipientId,
        amount: price,
        context,
        postId,
        messageId,
        creatorId: modelId, // Changed from modelId to creatorId for video requests
        description,
        tokenId: activeToken.id,
      };

      await makeOneClickPayment(payload as any);

      // Show success modal if enabled
      if (showSuccessOnPayment) {
        setShowSuccessModal(true);
      } else {
        // Call onPaymentSuccess callback immediately if success modal is disabled
        if (onPaymentSuccess) {
          onPaymentSuccess();
        }
      }
    } catch (error) {
      console.error("❌ One-click payment failed:", error);
      toast.error(
        (error as any)?.response?.data?.message || "One-click payment failed."
      );
    }
  };

  const showSubscriptionSummaryCard =
    context === "subscription" &&
    subscriptionSummary &&
    typeof price === "number" &&
    showPrice &&
    !effectiveAlreadySubscribed;

  return (
    <Box
      className={`${classes.ccbillContainer}${
        showSubscriptionSummaryCard
          ? ` ${classes.ccbillContainerSubscriptionWide}`
          : ""
      }${compactPostPurchase ? ` ${classes.ccbillContainerMinimal}` : ""}`}
    >
      {!compactPostPurchase && (
        <Box className={classes.securityIconContainer}>
          <img
            src={paymentCardsImage}
            alt="Payment cards"
            className={classes.securityIcon}
          />
        </Box>
      )}
      {!compactPostPurchase && !!title && (
        <Typography className={classes.ccbillTitle}>{title}</Typography>
      )}
      {!compactPostPurchase && !showSubscriptionSummaryCard && (
        <Typography className={classes.ccbillDescription}>
          {effectiveAlreadySubscribed
            ? "You are already subscribed."
            : finalDescription}
        </Typography>
      )}
      {price && showPrice && !effectiveAlreadySubscribed && !compactPostPurchase && (
        <>
          {showSubscriptionSummaryCard ? (
            <Box className={classes.subscriptionSummaryCard}>
              <Box className={classes.subscriptionSummaryLeft}>
                <Box
                  component="span"
                  className={classes.subscriptionTierBadge}
                >
                  {subscriptionSummary.planName}
                </Box>
                <Box className={classes.subscriptionPriceRow}>
                  <Typography
                    component="span"
                    className={classes.subscriptionPriceAmount}
                  >
                    ${price.toFixed(2)}
                  </Typography>
                  <Typography
                    component="span"
                    className={classes.subscriptionPricePeriod}
                  >
                    {subscriptionSummary.billingPeriod === "month"
                      ? " / month"
                      : " / week"}
                  </Typography>
                </Box>
                <Typography className={classes.subscriptionRenewalLine}>
                  {subscriptionSummary.billingPeriod === "month"
                    ? "Monthly"
                    : "Weekly"}
                  , renewal {subscriptionRenewalShortDate}, cancel anytime
                </Typography>
              </Box>
              <Box
                className={classes.subscriptionSummaryDivider}
                aria-hidden
              />
              <Box className={classes.subscriptionSummaryRight}>
                {subscriptionSummary.benefits.map((b, idx) => (
                  <Box
                    key={`${b}-${idx}`}
                    className={classes.subscriptionBenefitRow}
                  >
                    <img
                      src={markIcon}
                      alt=""
                      className={classes.subscriptionBenefitMark}
                    />
                    <Typography
                      component="span"
                      className={classes.subscriptionBenefitText}
                    >
                      {b}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          ) : (
            <Box className={classes.purchaseInfo}>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "8px",
                  marginBottom: "8px",
                }}
              >
                <Typography className={classes.purchaseLabel}>
                  Your purchase:
                </Typography>
                <Typography className={classes.purchaseTitle}>
                  {getPurchaseItemName()}
                </Typography>
              </Box>
              <Box className={classes.purchaseRow}>
                <Typography className={classes.purchaseLabel}>Total:</Typography>
                <Typography className={classes.totalPrice}>
                  ${price.toFixed(2)}
                </Typography>
              </Box>
            </Box>
          )}
        </>
      )}
      {checkingSubscription ? (
        <Button
          variant="contained"
          className={`${classes.proceedButton}${
            showSubscriptionSummaryCard
              ? ` ${classes.proceedButtonSubscriptionCheckout}`
              : ""
          }`}
          disabled
        >
          Checking...
        </Button>
      ) : effectiveAlreadySubscribed ? (
        <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
          <span style={{ color: "#f06ec4", fontWeight: 600, fontSize: "14px" }}>
            You are already subscribed
          </span>
        </Box>
      ) : (
        <>
          {buttonText && (
            <Button
              variant="outlined"
              className={`${classes.ccbillButton}${
                showSubscriptionSummaryCard
                  ? ` ${classes.ccbillButtonSubscriptionCheckout}`
                  : ""
              }`}
              onClick={handleProceedToCCBill}
            >
              <img
                src={ccBillIcon}
                alt="CCBill"
                className={classes.ccbillIcon}
              />
              {buttonText}
            </Button>
          )}
        </>
      )}
      <SuccessModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onContinue={() => {
          setShowSuccessModal(false);
          if (onPaymentSuccess) {
            onPaymentSuccess();
          }
        }}
      />
    </Box>
  );
};

export default CCBillPayment;
